import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "To experience true flow, try baking 👩‍🍳",
  "description": "",
  "published": "2018-11-14T00:00:00.000Z",
  "redirect_from": ["/blog/true-flow-baking/swizec/8725"],
  "categories": "Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Programmers love flow. That state of total absorption where you work on a task and the world ceases to exist.`}</p>
    <p>{`You graze the keys. A gentle caress. Just you and your code. Fingers gliding across the keyboard like poetry. Code so elegant it would make `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Edsger_W._Dijkstra"
      }}>{`Dijkstra`}</a>{` cry.`}</p>
    <p>{`Five minutes later, you look up. Emerge from your perfect little world. 3 hours have passed.`}</p>
    <p>{`Dazed, displaced, and a little hungry, you close your laptop. Happy.`}</p>
    <p><img parentName="p" {...{
        "src": "/7a8be1924464055e7b60b6e8b4e23141/media-2lxG3ySjtbpBe-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`That's great and all, but have you tried baking? Holy shit.`}</p>
    <p><em parentName="p">{`Baking`}</em>{`, baking is the real flow.`}</p>
    <p>{`No time to rest. Once you start, you can't stop until it's done. Constant motion. Constant pressure. Constant adrenaline. Rest for even a second, and you may have just ruined your whole bake.`}</p>
    <p>{`Watch `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/The_Great_British_Bake_Off"
      }}>{`The Great British Baking Show`}</a>{` if you don't believe me. It's on Netflix. Amazing show. Very wholesome and everyone's so nice to each other. Even the judges are super positive and constructive.`}</p>
    <p><img parentName="p" {...{
        "src": "/053bb244d36837e30bb9b5a6b968b418/media-26BRNqyHdCgrRPyWk-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Last night, I made a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Nut_roll#Potica"
      }}>{`potica`}</a>{`. It's a traditional holiday pastry from Slovenia that I've been making every Thanksgiving or Christmas since I moved to the US.`}</p>
    <p>{`Mom and grandma aren't here so I gotta make it myself. ¯`}<em parentName="p">{`(ツ)`}</em>{`/¯`}</p>
    <p>{`A little slice of home. But it's not as good as when they make it. 👵`}</p>
    <p>{`Here's what a two-and-a-half hour bake like that looks like. Pure flow. `}<a parentName="p" {...{
        "href": "https://www.kulinarika.net/recepti/17887/sladice/orehova-potica/"
      }}>{`Recipe`}</a>{`, if you can read it.`}</p>
    <p>{`You start at 10:30pm because of course you do. Put on some headphones, ask Spotify for a baking playlist. Yes, they exist.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/pic1.jpg",
        "alt": null
      }}></img></p>
    <p>{`You take a cup, warm up some milk, add a spoon of flour, bit of sugar, and a cube and a half of yeast.`}</p>
    <p>{`That's your timer. You gotta get the dough ready before the yeast starts spilling out of your cup.`}</p>
    <p>{`5 minutes. Maybe 10. Hope you picked a big mug coz that yeast mix is about to grow to 5x its volume.`}</p>
    <p>{`Sift your flour. Makes it nice and fluffy. Add a bit of salt and your sugar. Mix. Melt quarter kilo of butter. Add 4 yolks, keep the whites. Add your milk.`}</p>
    <p>{`Pour the butter. Make sure it's cool. Hot butter kills the yeast.`}</p>
    <p>{`Add some lemon zest, bit of rum.`}</p>
    <p>{`Hope you're ready. Yeast is spilling. Add it to the dough and knead until you get a nice soft dough of good consistency.`}</p>
    <p>{`Let your dough rise.`}</p>
    <p>{`Oh, but shit, you cooled the butter too much and used milk straight out of the fridge. Cold kills the yeast.`}</p>
    <p>{`Make sure the dough is warm. Put it on a bowl of hot water. Keep it cozy.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/pic2.jpg",
        "alt": null
      }}></img></p>
    <p>{`While your dough rises, you have juuuuust enough time to prep the filling.`}</p>
    <p>{`Hope you started soaking them raisins in some rum two hours ago. Gonna be dry and un-aromatic otherwise.`}</p>
    <p>{`Grind many walnuts down to almost a powder. Americans don't sell them finely ground enough.`}</p>
    <p>{`Roast.`}</p>
    <p>{`Make sure it doesn't burn. Use low heat. Patience. Smells perfect just before they burn then suddenly they're black.`}</p>
    <p>{`Add cinnamon. Bunch of heavy whipping cream. Also sugar. Some more lemon zest.`}</p>
    <p>{`Throw in some rum and the raisins. Make sure you don't make it runny. Stir and let simmer on low heat.`}</p>
    <p>{`Whisk your egg whites. You remembered to store them when separating yolks from the dough, right?`}</p>
    <p>{`While the dough rises and the filling simmers, you have time to clean your kitchen. Put away the clean dishes. Put everything dirty in the dishwasher.`}</p>
    <p>{`You need a large clean surface for your next step.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/pic3.jpg",
        "alt": null
      }}></img></p>
    <p>{`Mix gently the egg white fluff into your filling. Add a whole egg. Needs to be of a nice spreading consistency. Not runny. Not hard. Too thick, add some milk. Too runny, add some breadcrumbs.`}</p>
    <p>{`Don't overdo it. Both milk and breadcrumbs dilute that delicious taste of roasted walnuts and cinnamon and raisins and rum and chocolate powder.`}</p>
    <p>{`You added the chocolate powder, right? And you didn't forget to use less sugar if your hot chocolate powder comes sweetened, yeah?`}</p>
    <p>{`Split the dough in two. Roll it to about the thickness of a pinky. Maybe thinner. Maybe fatter. Depends on how well you think it's gonna keep rising.`}</p>
    <p>{`Spread the filling, roll it up into a roll. Put in a greased baking tin. Repeat with the other half.`}</p>
    <p>{`Whisk an egg and smear it over your potica. This creates a nice golden sheen when baked.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/pic4.jpg",
        "alt": null
      }}></img></p>
    <p>{`Preheat your oven. Let the potica rise for another 20 minutes.`}</p>
    <p>{`Bake for 50 minutes or until golden brown. When you tap on the top and it makes a hollow sound, you know it's done.`}</p>
    <p>{`Wait too long and it's dry and crumbly.`}</p>
    <p>{`While your potica bakes, you can clean the kitchen. Wipe down that floured counter top, put away all the dirty bowls and utensils. Start the dishwasher.`}</p>
    <p>{`Always leave your kitchen cleaner than you found it. It's part of baking.`}</p>
    <p>{`It's 2 hours later. Now you can rest. Where'd the time go lol?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/pic5.jpg",
        "alt": null
      }}></img></p>
    <p>{`Your potica came out perfect. Your tin was too small and you can see it exploded. That happens when it doesn't have enough room to rise while baking.`}</p>
    <p>{`But just look at that beautiful color 😋`}</p>
    <p>{`Let it rest. Cool down. Tomorrow, you find out if you were successful.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/pic6.jpg",
        "alt": null
      }}></img></p>
    <p>{`I rolled the dough too thin. There's no swirl. And my filling is too sweet. Forgot there was sugar in the chocolate.`}</p>
    <p>{`But the top layer didn't separate and the dough is perfect 🙌`}</p>
    <p>{`That was fun. Getting better every year.`}</p>
    <p>{`Cheers,`}</p>
    <p>{`~Swizec`}</p>
    <p>{`PS: No,seriously, try baking. It's very technical, super relaxing, and forces you in the flow. Your worries and concerns melt away when you're baking. There's no time.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      